module.exports = {"social":{"github":{"icon":"fab fa-github","href":"https://github.com/hackinteach/"},"wordpress":{"icon":"fab fa-wordpress","href":"https://hackinteachk.wordpress.com/"},"resume":{"icon":"fas fa-file-pdf","href":"/static/cv.pdf"}},"subheader":["BSc Computer Science","Mahidol University International College"],"contact":{"email":{"text":"webmaster(at)hackinteach(dot).com","icon":"fa-envelope"},"website":{"text":"www.nuttapat.me","icon":"fa-globe"},"location":{"text":"Bangkok, Thailand","icon":"fa-map-marker"}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/data.json
// module id = b3jg
// module chunks = 0